import { useCallback, useState } from 'preact/hooks';
import './ChatInput.less';
import { ChangeEvent } from 'preact/compat';
import TextInput from '../input/TextInput';

export type ChatInputProps = {
    onSubmit: (sentence: string) => void;
    placeholder?: string;
    disabled?: boolean;
    disclaimer?: string;
};

const ChatInput = ({
    onSubmit,
    placeholder,
    disabled,
    disclaimer
}: ChatInputProps) => {
    const [customSearchText, setCustomSearchText] = useState('');
    const onChangeText = useCallback(
        (event: ChangeEvent<HTMLTextAreaElement>) => {
            setCustomSearchText(event.currentTarget.value);
        },
        []
    );
    const onKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                if (!customSearchText.trim()) {
                    event.preventDefault();
                    return;
                }
                onSubmit(customSearchText.trim());
                setCustomSearchText('');
                event.preventDefault();
            }
        },
        [customSearchText]
    );
    return (
        <div className={`bri-ChatInput`}>
            <TextInput
                key={`custom-search-input`}
                value={customSearchText}
                onChange={onChangeText}
                placeholder={placeholder}
                maxLength={200}
                onKeyDown={onKeyDown}
                disabled={disabled}
                endIconId={customSearchText.trim() ? 'send' : undefined}
                onClickEndIcon={() => {
                    if (!customSearchText.trim()) {
                        return;
                    }
                    onSubmit(customSearchText.trim());
                    setCustomSearchText('');
                }}
            />
            {disclaimer && (
                <div className={'bri-ChatInput-disclaimer bri-BodySmallFont'}>
                    {disclaimer}
                </div>
            )}
        </div>
    );
};

export default ChatInput;
